import React, { useEffect, useState, useContext } from "react";
import Screen from '../components/Screen';
import usePaymentsActions from "../hooks/usePaymentsActions";
import { Link } from "react-router-dom";
import { HotelContext } from "../context/hotel";
import { usePaymentContext, PAYMENT_STATUSES, persistPaymentOutcome } from "../context/payment";
import { shouldStartPendingPoll } from "../helpers/paymentPending";
import { Player } from '@lottiefiles/react-lottie-player';
import { T } from "react-translator-component";

const PaymentResult = (props) => {
  const { getUrlPath, data: hotel } = useContext(HotelContext);
  const [ flowState, setFlowState ] = useState('initial');
  const [ loading, setLoading ] = useState(true);
  const [ errorMessage, setErrorMessage ] = useState(null);


  // 1. Estados para la UI
  const { setStatus, event, status, setError } = usePaymentContext();

  // 2. Obtener los parámetros de la URL
  // Asume que estás usando React Router u otro sistema para acceder a la ubicación.
  // Ejemplo: const query = new URLSearchParams(props.location.search);
  const query = new URLSearchParams(window.location.search);
  const sessionInternalId = query.get('sessionInternalId');
  const redirectResult = query.get('redirectResult');

  // 3. Efecto que se ejecuta solo al cargar el componente
  useEffect(() => {
    const doPreAuthorizationDetail = async () => {
      setLoading(true);
      setFlowState('pre-authorization-detail');

      try {
        const fallbackError = T("payments.payment-not-authorised");
        const r_pre_authorization = await event("pre-authorization-details", { data: { redirectResult } });
        console.log('8dic - r_pre_authorization', r_pre_authorization);
        if (r_pre_authorization.status) {
          setFlowState('payment-ok');
          const r_make_payments = await event("make-payments");
          console.log('8dic - r_make_payments', r_make_payments);
          if (shouldStartPendingPoll(r_make_payments)) {
            setFlowState('payed-ok');
            persistPaymentOutcome(hotel?.id, { status: PAYMENT_STATUSES.PAYMENT_PENDING, lastError: null });
          } else if (r_make_payments.status) {
            setFlowState('payed-ok');
            persistPaymentOutcome(hotel?.id, { status: PAYMENT_STATUSES.PAYMENT_OK, lastError: null });
          } else {
            setFlowState('payment-failed');
            const failMsg = r_make_payments?.refusalReasonDetailed || r_make_payments?.refusalReason || fallbackError;
            setError(failMsg);
            setStatus(PAYMENT_STATUSES.PAYMENT_FAILED);
            persistPaymentOutcome(hotel?.id, { status: PAYMENT_STATUSES.PAYMENT_FAILED, lastError: failMsg });
          }
        } else {
          setFlowState('payment-failed');
          const failMsg = r_pre_authorization?.detail || fallbackError;
          setError(failMsg);
          setStatus(PAYMENT_STATUSES.AUTHORIZATION_FAILED);
          persistPaymentOutcome(hotel?.id, { status: PAYMENT_STATUSES.AUTHORIZATION_FAILED, lastError: failMsg });
        }
        //   console.log('1dic - MAKE PAYMENTS NOW');
        //   setFlowState('make-payments');
        //   console.log('1dic - r_make_payments', r_make_payments);
        //   if (r_make_payments.status) {
        //     // setPaymentStatus('OK');
        //     // setStatus(PAYMENT_STATUSES.PAYMENT_OK);
        //     setFlowState('payed-ok');
        //   } else {
        //     // setPaymentStatus('FAIL');
        //     // setStatus(PAYMENT_STATUSES.PAYMENT_FAILED);
        //     setErrorMessage("Pago no autorizado.");
        //     setFlowState('payment-failed');
        //   }
        // } else {
        //   // setStatus(PAYMENT_STATUSES.AUTHORIZATION_FAILED);
        //   setError("Authorization failed 1111");
        //   setStatus('payment-failed');
        // }
      } catch (error) {
        // setPaymentStatus('FAIL');
        // setErrorMessage("Error de conexión al finalizar el pago.");
        console.error("11nov - Error finalizing payment:", error);
        const failMsg = T("payments.payment-not-authorised");
        setError(failMsg);
        setStatus(PAYMENT_STATUSES.AUTHORIZATION_FAILED);
        persistPaymentOutcome(hotel?.id, { status: PAYMENT_STATUSES.AUTHORIZATION_FAILED, lastError: failMsg });
      } finally {
        setLoading(false);
        window.location.href = getUrlPath("checkin/edit-new?gostep=payment");
      }

      // try {
      //   // Llama a tu endpoint de backend para finalizar el pago.
      //   // NOTA: Este endpoint de tu backend debe ser el que llama a /payments/details
      //   const response = await fetch('/api/payments/finalize', {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/json' },
      //     body: JSON.stringify({ 
      //       checkinId: checkinId, 
      //       details: details 
      //     }),
      //   });
        
      //   const result = await response.json();

      //   if (response.ok && result.success) {
      //     // El pago fue Autorizado y el token fue almacenado en el backend
      //     setPaymentStatus('OK');
      //   } else {
      //     // Fallo en la autorización o en el almacenamiento del token
      //     setPaymentStatus('FAIL');
      //     setErrorMessage(result.message || "Pago no autorizado.");
      //   }

      // } catch (error) {
      //   setPaymentStatus('FAIL');
      //   setErrorMessage("Error de conexión al finalizar el pago.");
      //   console.error("Error finalizing payment:", error);
      // } finally {
      //   setLoading(false);
      // }
    };

    // Asegúrate de que tienes detalles de pago antes de llamar a la API
    if (redirectResult) {
      console.log('16dic - redirectResult', redirectResult);
      console.log('16dic - flowState', flowState);
      if (flowState === 'initial') {
        doPreAuthorizationDetail();
      } else {
        setFlowState('already-sent');
      }
    } else {
      setFlowState('parameters-missing');
    }
  }, [ redirectResult ]);

  // 4. Renderizado del Componente
  // const renderContent = () => {
  //   if (loading) {
  //     return (
  //       <div className="loading-state">
  //         <h3>Finalizando Pago y Verificando Tarjeta...</h3>
  //         <p>Por favor, no cierre ni actualice esta ventana.</p>
  //       </div>
  //     );
  //   }

  //   {console.log('11nov - paymentStatus', paymentStatus)}

  //   return (
  //     <div className="payment-ok">

  //       <Player
  //         // ref={this.player} // set the ref to your class instance
  //         autoplay={true}
  //         loop={false}
  //         keepLastFrame={true}
  //         src="/lottie/payment-ok.json"
  //         style={{ height: '500px', width: '300px' }}
  //       ></Player>


  //       <div className="text-center">
  //         <h3 className="text-success">Pago Exitoso</h3>
  //         <p>Tu tarjeta ha sido verificada y almacenada de forma segura.</p>
  //         <Link to={getUrlPath("checkin/edit-new")}>Continuar con el Check-in »</Link>
  //       </div>
  //     </div>
  //   );

  return (
    <Screen 
    showBackButton={false}
       section={"payment-result"}
    >
      {loading && <div className="loading text-center w-100" style={{ marginTop: '120px' }}>
                        <div className="spinner-border"></div>
                    </div>}
      {(flowState === "parameters-missing" || flowState === "already-sent") && <div className="text-center mt-3">
        {flowState === "parameters-missing" && <p className="text-danger mb-0">Parameters missing</p>}
        {flowState === "already-sent" && <p className="text-danger mb-0">Already sent</p>}
        <Link to={getUrlPath("checkin/edit-new?gostep=payment")}>Go to Check-in »</Link>
      </div>}
        
        {/* {(status === PAYMENT_STATUSES.AUTHORIZATION_FAILED || status === PAYMENT_STATUSES.PAYMENT_FAILED) && <div>
          <Player
            autoplay={true}
            loop={false}
            keepLastFrame={true}
            src="/lottie/payment-fail.json"
            style={{ height: '500px', width: '300px' }}
          ></Player>
          <p className="text-danger">Ha ocurrido un error al autorizar el pago.</p>
        </div>} */}
        {/* {status === PAYMENT_STATUSES.PAYMENT_OK && <div>
          <Player
            autoplay={true}
            loop={false}
            keepLastFrame={true}
            src="/lottie/payment-ok.json"
            style={{ height: '500px', width: '300px' }}
          ></Player>
          <p className="text-danger">Ha ocurrido un error al autorizar el pago.</p>
        </div>} */}
        {/* <small>Volviendo al webcheckin en 5 segundos...</small> */}
        
      {/* </div> */}

      {/* <div className="alert alert-info text-center" style={{ marginTop: 10 }}>
        {errorMessage && <p className="text-danger mb-0">Error: {errorMessage}</p>}
        <p className="mb-0 font-size-sm">STATUS: {flowState}</p>
        <p className="mb-0 font-size-sm">PAYMENT STATUS: {status}</p>
      </div> */}
    </Screen>
  );
}

export default PaymentResult;